import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import Icon from "../icons";
import { Button } from "../utils";
import * as styles from "./styles.module.scss";

const Modal = ({ config }) => {
  const { closeFn, children, size, isAlert } = config;

  const modalSize = {
    "fit-content": styles.fitcontent,
    small: styles.small,
    large: styles.large,
    fullscreen: styles.fullscreen,
  };

  return (
    <div
      className={`${styles.defaultModal} ${isAlert && styles.alertModal} `}
      aria-hidden={"false"}
    >
      <div
        className={`
          ${styles.modalBox}
          ${" "}
          ${modalSize[size]}
        `}
      >
        <Button className={styles.closeBtn} onClick={closeFn}>
          <Icon icon="X" size="S" />
        </Button>
        {children}
      </div>
      <div className={styles.modalOverlay} onClick={closeFn} />
    </div>
  );
};

interface ModalProps {
  closeFn: Function;
  size: SizeOptions;
  overflow?: boolean;
  isAlert?: boolean;
}

type SizeOptions = "fit-content" | "small" | "large" | "fullscreen";

const ModalComponent = (props: ModalProps) => {
  const { overflow = true } = props;
  useEffect(() => {
    if (overflow) {
      document.getElementsByTagName("body")[0].style.overflow = "hidden";
      document.getElementById("___gatsby").style.overflow = "hidden";
    }
    return () => {
      document.getElementsByTagName("body")[0].style.overflow = null;
      document.getElementById("___gatsby").style.overflow = null;
    };
  }, []);

  return ReactDOM.createPortal(
    <Modal config={props} />,
    document.querySelector("div")
  );
};

export default ModalComponent;
